import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const PassengerAdditionWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "passenger-addition-template-wrapper",
  },
)`
  width: 546px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border: 1px dashed ${greyMui._400};
  padding: 12px;

  .section-title {
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.57;
  }
`;

export const PassengerAdditionRowStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "passenger-addition-row",
})`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  border: 1px solid ${greyMui._200};
  padding: 6px;
`;

export const PassengerAdditionFormStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "passenger-addition-form",
})`
  display: flex;
  align-items: flex-end;
  gap: 24px;

  .form-fields {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
  }

  .form-buttons {
    display: flex;
  }
`;
